<template>
  <div>
    <zj-layout-container v-loading="loading" :element-loading-text="loadingText">
      <zj-layout-header>
        <div class="listtitle">投诉查询</div>
        <el-form class="zj-search-form" ref="form" :model="form" :label-width="labelWidth">
          <el-row>
            <el-col :span="6">
              <el-form-item label="投诉人">
                <el-input v-model="person" placeholder="请输入投诉人"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="投诉手机号">
                <el-input v-model="tel" placeholder="请输入手机号"></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item label="投诉日期">
                <el-date-picker
                  v-model="date"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  style="width: 60rem"
                  unlink-panels
                ></el-date-picker>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="投诉来源">
                <el-select v-model="ComplaintSource" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintSourceArr"
                    :key="item.ItemValue"
                    :label="item.Description"
                    :value="item.ItemValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
          </el-row>
          <el-row>
            <el-col :span="6">
              <el-form-item label="投诉状态">
                <el-select v-model="status" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintStatusArr1"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <!-- <el-col :span="6">
              <el-form-item label="投诉类型">
                <el-select v-model="ComplaintSubType" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintSubTypeArr"
                    :key="item.ItemValue"
                    :label="item.Description"
                    :value="item.ItemValue"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col :span="6">
              <el-form-item label="投诉部门">
                <el-select v-model="ComplaintDepartmentId" placeholder="请选择">
                  <el-option key label="全部" value></el-option>
                  <el-option
                    v-for="item in ComplaintDepartments"
                    :key="item.OrgId"
                    :label="item.OrgName"
                    :value="item.OrgId"
                  ></el-option>
                </el-select>
              </el-form-item>
            </el-col> -->
            <el-form-item label class="right">
              <el-button @click="onSearch">查 询</el-button>
              <el-button @click="onCancel">清 理</el-button>
            </el-form-item>
          </el-row>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-button-bar">
          <el-button size="mini" @click="onAdd" v-if="isAdd">添 加</el-button>
        </div>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table :data="tableData" ref="multipleTable" border style="width: 100%" fixed>
              <el-table-column type="index" label="序号" width="80" align="center"></el-table-column>
              <el-table-column prop="content" label="投诉内容"></el-table-column>
              <el-table-column
                prop="platform"
                label="投诉来源"
                :formatter="SourceToNameConverter"
              ></el-table-column>
              <el-table-column prop="createdate" label="投诉时间" :formatter="formatDate"></el-table-column>
              <el-table-column prop="name" label="投诉人"></el-table-column>
              <el-table-column prop="phone" label="联系电话"></el-table-column>
              <el-table-column
                prop="status"
                label="投诉状态"
                :formatter="StatusToNameConverter"
              ></el-table-column>
              <el-table-column label="操作" width="120" align="center" v-if="!IsAdministrator">
                <template slot-scope="scope">
                  <template>
                    <el-button
                      @click="queryDetail(scope.$index, scope.row)"
                      type="text"
                      size="small"
                    >查看</el-button>
                  </template>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
  </div>
</template>

<script>
import ZJApp from "../../../../../app";
import MyApis from "../../../apis";
import Apis from "../../../../../../api";
import permissionsApi from "../../../../../../request/permissionsApi";
import ComplaintApi from "../../../apis/src/ComplaintApi";
const utils = ZJApp.ZJUtils;
export default {
  name: "ComplaintAllView",
  controller: "UI",
  action: "ComplaintAllView",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      person: "",
      tel: "",
      total: 0,
      tableData: [],
      Content: "",
      loading: false,
      loadingText: "加载中...",
      date: "",
      //TODO 可配置下拉菜单
      ComplaintSource: "",
      ComplaintSourceArr: [
        { value: 6, label: "电话" },
        { value: 7, label: "其他" }
      ],
      status: "",
      // ComplaintStatusArr: [
      //   { value: 1, label: "待受理" },
      //   { value: 2, label: "已受理" },
      //   { value: 3, label: "不受理" },
      //   { value: 4, label: "已处理" },
      //   { value: 5, label: "已结案" }
      // ],
      ComplaintStatusArr1: [
        { value: 0, label: "待受理" },
        { value: 1, label: "已受理" },
        { value: 2, label: "不予受理" },
        { value: 3, label: "处理完成" },
        { value: 4, label: "重诉待受理" },
        { value: 5, label: "重诉已受理" },
        { value: 6, label: "已完结" }
      ],
      ComplaintSubType: "",
      ComplaintSubTypeArr: [
        { value: 1, label: "景区投诉" },
        { value: 2, label: "环境投诉" },
        { value: 3, label: "服务投诉" },
        { value: 4, label: "物价投诉" },
        { value: 5, label: "其他投诉" }
      ],
      ComplaintDepartmentId: "",
      ComplaintDepartments: [],
      isAdd: false,
      ComplaintStatuses: [],
      ComplaintDepartmentIds: [],
      IsAdministrator: false
    };
  },
  created: function() {
    this.search();
    this.bindDatabase();
    // if (!this.CNF("app.isBiaoZhunHua")) 
    // this.GetUserIsAdministrator();
  },
  mounted: function() {
    if (this.CNF("app.isBiaoZhunHua")) {
      // this.getBJDepartments();
      this.initBJ();
    } else {
      this.getTopDepartments();
      this.init();
    }
    setTimeout(() => {
      this.search();
    }, 300);
    this.logInfo.ActionName = "投诉管理查询";
    this.logInfo.LogMessage = "投诉管理查询";
    this.logInfo.ModuleName = "投诉系统";
    this.logInfo.PageName = "投诉管理列表";
    this.addOperationLog();
  },
  methods: {
    bindDatabase() {
      this.loading = true;
      this.loadingText = "加载中...";
      return utils
        .waitAll([
          this.config.getUValue("ComplaintSubSystem:ComplaintSource:", ""),
          this.config.getUValue("ComplaintSubSystem:ComplaintStatus:", ""),
          this.config.getUValue("ComplaintSubSystem:ComplaintSubType:", "")
        ])
        .then(r => {
          this.ComplaintSourceArr = r[0].JValue;
          this.ComplaintStatusArr = r[1].JValue;
          this.ComplaintSubTypeArr = r[2].JValue;

          this.loading = false;

          return r;
        })
        .catch(e => {
          console.error(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
          this.loading = false;
        });
    },
    //北京统一登录时获取北京所有部门
    // getBJDepartments() {
    //   permissionsApi
    //     .findOrganizationTree({ projectCode: this.CNF("app.perProjectCode") })
    //     .then(res => {
    //       if (res.code == 0) {
    //         if (res.data.length > 0) {
    //           const departs = this.flattenTree(res.data);
    //           console.log(departs);
    //           this.ComplaintDepartments = departs.map(item => {
    //             return { OrgId: item.code, OrgName: item.name };
    //           });
    //           //当角色不是管理员和投诉受理岗时，只能查看本部门的投诉信息
    //           const IsAdminRole = this.user.userInfo.roleSystem.filter(r => {
    //             return r.name.indexOf("管理员") >= 0;
    //           });

    //           const IsAcceptRole = this.user.userInfo.roleSystem.filter(r => {
    //             return r.name.indexOf("投诉受理岗") >= 0;
    //           });

    //           if (
    //             IsAdminRole.length <= 0 &&
    //             this.user.Departments != null &&
    //             this.user.Departments.length > 0 &&
    //             IsAcceptRole.length <= 0
    //           ) {
    //             this.ComplaintDepartments = this.user.Departments;
    //             this.ComplaintDepartmentIds = this.ComplaintDepartments.map(
    //               item => {
    //                 return item.OrgId;
    //               }
    //             );
    //           }
    //         }
    //       } else {
    //         this.errmsg(res.msg);
    //       }
    //       console.log(this.ComplaintDepartments);
    //     });
    // },
    flattenTree(nodes) {
      var r = [];
      if (Array.isArray(nodes)) {
        for (var i = 0, l = nodes.length; i < l; i++) {
          r.push(nodes[i]); // 取每项数据放入一个新数组
          if (
            Array.isArray(nodes[i]["children"]) &&
            nodes[i]["children"].length > 0
          )
            // 若存在children则递归调用，把数据拼接到新数组中，并且删除该children
            r = r.concat(this.flattenTree(nodes[i]["children"]));
          delete nodes[i]["children"];
        }
      }
      return r;
    },
    //绑定部门信息
    getTopDepartments() {
      new Apis.OrgApi()
        .FindByConditions({ OrgCode: this.config.app.org_code })
        .then(r => {
          r = r.data.Data;
          if (r != null && r.length > 0) {
            this.getDepartments(r[0].OrgId);
          }
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    getDepartments(OrgId) {
      new Apis.OrgApi()
        .FindByConditions({ ParentOrgId: OrgId })
        .then(r => {
          r = r.data.Data;
          this.ComplaintDepartments = r;
          if (
            !this.IsAdministrator &&
            this.user.Departments != null &&
            this.user.Departments.length > 0 &&
            this.user.Role[0].data.Data.RoleName != "投诉受理岗"
          ) {
            this.ComplaintDepartments = this.ComplaintDepartments.filter(p => {
              return p.OrgId == this.user.Departments[0].OrgId;
            });
            this.ComplaintDepartmentIds = this.ComplaintDepartments.map(
              item => {
                return item.OrgId;
              }
            );
          }
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    GetUserIsAdministrator() {
      let user = this.user;
      var userId = user.UserId;
      let RoleInfoSearch = {
        UserId: userId
      };
      new Apis.RoleApi()
        .IsAdministrator(RoleInfoSearch)
        .then(r => {
          r = r.data.Data;
          this.IsAdministrator = r;
        })
        .catch(e => {
          console.log(e);
          this.errmsg(e.RspMsg ? e.RspMsg : "服务异常，请联系管理员！");
        });
    },
    init() {
      const RoleName = this.user.Role[0].data.Data.RoleName || "";
      if (RoleName) {
        switch (RoleName) {
          case "投诉受理岗":
            this.ComplaintStatusArr = [
              { ItemValue: 1, Description: "待受理" },
              { ItemValue: 3, Description: "不受理" }
            ];
            this.isAdd = true;
            break;
          case "投诉承办岗":
            this.ComplaintStatusArr = [{ ItemValue: 2, Description: "已受理" }];
            break;
          case "投诉办结岗":
            this.ComplaintStatusArr = [
              { ItemValue: 4, Description: "已处理" },
              { ItemValue: 5, Description: "已结案" }
            ];
            break;
        }
        if (this.ComplaintStatusArr.length > 0) {
          this.ComplaintStatuses = this.ComplaintStatusArr.map(item => {
            return item.ItemValue;
          });
        }
      }
    },
    initBJ() {
      if (this.user && this.user.userInfo.roleSystem.length > 0) {
        const IsAcceptRole = this.user.userInfo.roleSystem.filter(r => {
          return r.name.indexOf("投诉受理岗") >= 0;
        });
        const IsUnderTakeRole = this.user.userInfo.roleSystem.filter(r => {
          return r.name.indexOf("投诉承办岗") >= 0;
        });
        const IsFinishRole = this.user.userInfo.roleSystem.filter(r => {
          return r.name.indexOf("投诉办结岗") >= 0;
        });
        if (IsAcceptRole.length > 0) {
          this.ComplaintStatusArr = [
            { ItemValue: 1, Description: "待受理" },
            { ItemValue: 3, Description: "不受理" }
          ];
          this.isAdd = true;
        } else if (IsUnderTakeRole.length > 0) {
          this.ComplaintStatusArr = [{ ItemValue: 2, Description: "已受理" }];
        } else if (IsFinishRole.length > 0) {
          this.ComplaintStatusArr = [
            { ItemValue: 4, Description: "已处理" },
            { ItemValue: 5, Description: "已结案" }
          ];
        }
        if (this.ComplaintStatusArr) {
          this.ComplaintStatuses = this.ComplaintStatusArr.map(item => {
            return item.ItemValue;
          });
        }
      }
    },
    search() {
      const that = this;
      let searchInfo = {
        Content: this.Content,
        createdate1:
          this.date == ""
            ? ""
            : this.date[0].format("yyyy-MM-dd"),
        createdate2:
          this.date == ""
            ? ""
            : this.date[1].format("yyyy-MM-dd"),
        status: this.status == "" ? 0 : this.status,
        ComplaintStatuses: this.ComplaintStatuses,
        ComplaintType: this.ComplaintType == "" ? 0 : this.ComplaintType,
        ComplaintSubType:
          this.ComplaintSubType == "" ? 0 : this.ComplaintSubType,
        ComplaintSource: this.ComplaintSource == "" ? 0 : this.ComplaintSource,
        ComplaintDepartmentId:
          this.ComplaintDepartmentId == "" ? "0" : this.ComplaintDepartmentId,
        ComplaintDepartmentIds: this.ComplaintDepartmentIds,
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        TotalCount: 0,
        StartNumber: 0,
        EndNumber: 0
      };
      this.loading = true;
      ComplaintApi.GetSuggestList({
        "page": searchInfo.PageIndex,
        "size":searchInfo.PageSize,
        "person": that.person,
         "status": that.status,
         "tel": that.tel,
        "createdate1": searchInfo.createdate1,
        "createdate2": searchInfo.createdate2
      })
      .then(res => {
        this.tableData = res.data;
        this.total = res.count;
        this.loading = false;
      }).catch(e => {
        this.loading = false;
        console.log(e);
        this.errmsg(e.msg ? e.msg : "服务异常，请联系管理员！");
      });
    },
    //添加
    onAdd() {
      this.$router.push({
        path: "/plugin/complaint/UI/ComplaintManagerInfo",
        query: {
          type: "add",
          formShow: "accept"
        }
      });
    },
    //查看
    queryDetail(index, row) {
      this.$router.push({
        path: "/plugin/complaint/ui/ComplaintAllInfo1",
        query: { Info: row, InfoId: row.Id, type: "look", formShow: "accept" }
      });
    },
    // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.search();
    },
    clearsearch() {
      this.person = "";
      this.tel = "";
      this.status = "";
      this.ComplaintType = "";
      this.ComplaintSubType = "";
      this.ComplaintSource = "";
      this.ComplaintDepartmentId = "";
      this.date = "";
    },
    // 点击取消按钮
    onCancel() {
      this.clearsearch();
      this.search();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.search();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.search();
    },
    SourceToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      console.log(data);
      console.log(this.ComplaintSourceArr);
      const SourceName = this.ComplaintSourceArr.map(item => {
        if (item.ItemValue == data) return item.Description;
      }).join("");
      if (SourceName == null || SourceName == "") {
        return data;
      }
      return SourceName;
    },
    // table投诉状态
    StatusToNameConverter(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      const StatusName = this.ComplaintStatusArr1.map(item => {
        if (item.value == data) return item.label;
      })
      return StatusName;
    },
    //日期列表展示格式
    formatDate(row, column) {
      // 获取单元格数据
      let data = row[column.property];
      if (data == null || data == "0001-01-01T00:00:00") {
        return null;
      }
      return new Date(data).format("yyyy-MM-dd hh:mm");
    }
  }
};
</script>
